var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75278 6.66745C6.75278 5.16362 6.75117 3.69585 6.75386 2.2286C6.75494 1.62116 7.07782 1.13746 7.59283 0.953445C8.4684 0.640305 9.32351 1.25475 9.32943 2.21139C9.33643 3.36387 9.33105 4.5169 9.33105 5.66992C9.33105 5.99167 9.33105 6.31342 9.33105 6.66799C9.415 6.66799 9.49034 6.66799 9.56514 6.66799C10.9686 6.66799 12.3721 6.66584 13.7756 6.66907C14.3816 6.67014 14.8648 6.99673 15.0467 7.51325C15.3319 8.32193 14.8088 9.1489 13.9532 9.23714C13.8536 9.24736 13.753 9.24575 13.6529 9.24629C12.2995 9.24629 10.946 9.24629 9.59312 9.24629H9.33105V9.48625C9.33105 10.911 9.33266 12.3363 9.33051 13.761C9.32943 14.3824 9.00654 14.8667 8.48077 15.0496C7.62835 15.3466 6.78077 14.758 6.75547 13.8422C6.74256 13.3628 6.75225 12.8829 6.75225 12.403C6.75225 11.4361 6.75225 10.4698 6.75225 9.50293C6.75225 9.42545 6.75225 9.34798 6.75225 9.24629H6.50739C5.08237 9.24629 3.65736 9.2479 2.23288 9.24521C1.62316 9.24413 1.13991 8.92508 0.953708 8.41124C0.643197 7.55522 1.23731 6.6922 2.16239 6.67068C2.7565 6.65723 3.35115 6.66745 3.94527 6.66745C4.80469 6.66745 5.66357 6.66745 6.52299 6.66745H6.75278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.46d20d61f6c0b70bf8e5e558c85b9472.svg";
export { ForwardRef as ReactComponent };